export default __webpack_public_path__ + "static/media/forbidden.2f18d35b.svg";